import { GlobalClientErrorOverlay } from "../../../../../../shared/frontend/feedback/globalClientErrorHandlers";
import { requestManualAppReload } from "../system/appReloadCoordinator";
import { showClientErrorDetails, useClientErrorRecoveryLabels } from "./clientErrorRecovery";

/** Fehler aus window.onerror und unhandledrejection, gemeldet über die Shared-Handler aus main.tsx. */
export function GlobalErrorOverlay() {
  const labels = useClientErrorRecoveryLabels();
  return (
    <GlobalClientErrorOverlay
      labels={labels}
      showDeveloperDetails={showClientErrorDetails()}
      onBackToDashboard={() => { window.location.hash = "#/dashboard"; }}
      onReload={requestManualAppReload}
    />
  );
}
